import { Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';


@Component({
  selector: 'app-custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.scss'
})
export class CustomToastComponent {
  emailAddress: string | undefined;
  sub: string | undefined;
  body: string | undefined;
  Uservalue: any;
  user: any;

  constructor(
    public snackBarRef: MatSnackBarRef<CustomToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public dialog: MatDialog
  ) { }

}
